(function () {
  function init(root) {
    if (!root || root.getAttribute('data-ms-ready')) return;
    root.setAttribute('data-ms-ready', 'true');
    var cfgEl = root.querySelector('[data-ms-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scrollBehavior = reduceMotion ? 'auto' : 'smooth';

    var moneyParts = (function () {
      var sample = String(cfg.moneySample || '');
      var match = sample.match(/\d[\d.,'\s\u00a0\u202f]*\d|\d/);
      if (!match) return null;
      var num = match[0];
      var decimals = 0;
      var decimal = '.';
      var tail = num.match(/[.,](\d{1,3})$/);
      if (tail && tail[1].length !== 3) {
        decimals = tail[1].length;
        decimal = num.charAt(num.length - decimals - 1);
      }
      var whole = decimals ? num.slice(0, num.length - decimals - 1) : num;
      var sep = whole.match(/[^\d]/);
      return {
        prefix: sample.slice(0, match.index),
        suffix: sample.slice(match.index + num.length),
        decimals: decimals,
        decimal: decimal,
        thousands: sep ? sep[0] : ''
      };
    })();
    function money(cents) {
      var value = Math.round(cents) / 100;
      if (!moneyParts) return value.toFixed(2);
      var parts = value.toFixed(moneyParts.decimals).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, moneyParts.thousands);
      return moneyParts.prefix + whole + (parts[1] ? moneyParts.decimal + parts[1] : '') + moneyParts.suffix;
    }

    var rate = 1;
    try { rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch (e) {}

    var variants = cfg.variants || [];
    var sets = cfg.sets && cfg.sets.length ? cfg.sets : [{ qty: 1, off: 0, compare: 'none' }];
    function byId(id) {
      id = Number(id);
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return null;
    }
    function repeat(v, n) {
      var list = [];
      for (var i = 0; i < Math.max(n, 1); i++) list.push(v);
      return list;
    }
    function mainVariant() {
      var checked = root.querySelector('[data-ms-color]:checked');
      return byId(checked ? checked.value : cfg.selectedId) || byId(cfg.selectedId) || variants[0];
    }
    function currentSetIndex() {
      var checked = root.querySelector('[data-ms-set]:checked');
      return checked ? Number(checked.value) : 0;
    }
    function unitVariants(index) {
      var set = sets[index] || sets[0];
      if (set.qty <= 1) return [mainVariant()];
      var card = root.querySelector('[data-ms-set-card="' + index + '"]');
      var selects = card ? card.querySelectorAll('[data-ms-unit]') : [];
      var list = [];
      for (var i = 0; i < set.qty; i++) {
        list.push((selects[i] && byId(selects[i].value)) || mainVariant());
      }
      return list;
    }
    function totals(index, units) {
      var set = sets[index] || sets[0];
      var price = 0;
      var compare = 0;
      units.forEach(function (v) {
        price += v.price;
        if (set.compare === 'compare_at') compare += v.compare > v.price ? v.compare : v.price;
        else if (set.compare === 'price') compare += v.price;
      });
      price = Math.max(price - Math.round((set.off || 0) * rate), 0);
      return { price: price, compare: compare > price ? compare : 0 };
    }

    var form = root.querySelector('form.ms-form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var express = root.querySelector('[data-ms-express]');
    var errorBox = root.querySelector('[data-ms-error]');
    var addButtons = root.querySelectorAll('[data-ms-add]');
    var stickyImg = root.querySelector('.ms-sticky__img');
    var mediaFor = {};
    root.querySelectorAll('[data-ms-color]').forEach(function (input) {
      if (input.getAttribute('data-media-id')) mediaFor[input.value] = input.getAttribute('data-media-id');
    });
    function updateStickyImage(variant) {
      if (!stickyImg || !gallery || !variant) return;
      var mediaId = mediaFor[String(variant.id)];
      var slideImg = mediaId ? gallery.querySelector('[data-media-id="' + mediaId + '"] img') : null;
      var src = slideImg ? slideImg.getAttribute('src') : '';
      if (!src) return;
      src = src.replace(/([?&])width=\d+/, '$1width=120');
      if (stickyImg.getAttribute('src') === src) return;
      stickyImg.removeAttribute('srcset');
      stickyImg.removeAttribute('sizes');
      stickyImg.setAttribute('src', src);
    }

    function render() {
      var main = mainVariant();
      if (!main) return;
      var nameEl = root.querySelector('[data-ms-color-name]');
      if (nameEl) nameEl.textContent = main.title;
      var current = currentSetIndex();
      for (var i = 0; i < sets.length; i++) {
        var card = root.querySelector('[data-ms-set-card="' + i + '"]');
        if (!card) continue;
        var t = totals(i, i === current ? unitVariants(i) : repeat(main, sets[i].qty));
        var priceEl = card.querySelector('[data-ms-set-price]');
        var compareEl = card.querySelector('[data-ms-set-compare]');
        var saveEl = card.querySelector('[data-ms-set-save]');
        if (priceEl) priceEl.textContent = money(t.price);
        if (compareEl) { compareEl.textContent = t.compare ? money(t.compare) : ''; compareEl.hidden = !t.compare; }
        if (saveEl) { saveEl.textContent = t.compare ? cfg.labels.save + ' ' + money(t.compare - t.price) : ''; saveEl.hidden = !t.compare; }
        card.classList.toggle('is-selected', i === current);
      }
      var units = unitVariants(current);
      var sum = totals(current, units);
      root.querySelectorAll('[data-ms-price]').forEach(function (el) { el.textContent = money(sum.price); });
      root.querySelectorAll('[data-ms-compare]').forEach(function (el) { el.textContent = sum.compare ? money(sum.compare) : ''; el.hidden = !sum.compare; });
      var available = units.every(function (v) { return v.available; });
      addButtons.forEach(function (button) {
        if (button.getAttribute('aria-busy') !== 'true') button.disabled = !available;
        var label = button.querySelector('[data-ms-add-label]');
        if (label) label.textContent = available ? cfg.labels.add : cfg.labels.soldout;
      });
      if (idInput && String(idInput.value) !== String(units[0].id)) {
        idInput.value = units[0].id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (qtyInput) qtyInput.value = units.length;
      updateStickyImage(units[0]);
      if (express) express.hidden = units.length > 1 || !available;
    }
    function clearError() { if (errorBox) errorBox.textContent = ''; }

    var gallery = root.querySelector('[data-ms-gallery]');
    function showMedia(mediaId) {
      if (!gallery || !mediaId) return;
      var target = gallery.querySelector('[data-media-id="' + mediaId + '"]');
      if (target) gallery.scrollTo({ left: target.offsetLeft, behavior: scrollBehavior });
    }

    root.querySelectorAll('[data-ms-color]').forEach(function (input) {
      input.addEventListener('change', function () {
        root.querySelectorAll('[data-ms-unit]').forEach(function (select) { select.value = input.value; });
        clearError();
        render();
        showMedia(input.getAttribute('data-media-id'));
      });
    });
    root.querySelectorAll('[data-ms-set]').forEach(function (input) {
      input.addEventListener('change', function () { clearError(); render(); });
    });
    root.querySelectorAll('[data-ms-unit]').forEach(function (select) {
      select.addEventListener('change', function () { clearError(); render(); });
    });

    function addToCart(event) {
      if (event) event.preventDefault();
      var units = unitVariants(currentSetIndex());
      var counts = {};
      var order = [];
      units.forEach(function (v) {
        if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id] += 1;
      });
      var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
      addButtons.forEach(function (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
      clearError();
      var buyNow = cfg.afterAdd === 'checkout';
      var start = buyNow
        ? fetch(cfg.cartUrl + '/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        : Promise.resolve();
      start.then(function () {
        return fetch(cfg.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      }).then(function () {
        window.location.href = cfg.afterAdd === 'checkout' ? cfg.checkoutUrl : cfg.cartUrl;
      }).catch(function (error) {
        addButtons.forEach(function (button) { button.removeAttribute('aria-busy'); });
        render();
        if (errorBox) errorBox.textContent = (error && (error.description || error.message)) || cfg.labels.error;
      });
    }
    if (form) form.addEventListener('submit', addToCart);
    var stickyAdd = root.querySelector('[data-ms-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', addToCart);

    function safePlay(video) {
      try {
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function () {});
      } catch (e) {}
    }
    var soundTargets = [];
    function setSound(target, on) {
      target.video.muted = !on;
      target.button.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (target.label) target.label.textContent = on ? cfg.labels.soundOn : cfg.labels.soundOff;
      if (on) safePlay(target.video);
    }
    function toggleSound(target) {
      var turnOn = target.button.getAttribute('aria-pressed') !== 'true';
      soundTargets.forEach(function (other) { if (other !== target) setSound(other, false); });
      setSound(target, turnOn);
    }
    var heroButton = root.querySelector('[data-ms-sound]');
    var heroVideo = root.querySelector('[data-ms-hero-video] video');
    if (heroButton) {
      if (!heroVideo) {
        heroButton.hidden = true;
      } else {
        var heroTarget = { video: heroVideo, button: heroButton, label: heroButton.querySelector('[data-ms-sound-label]') };
        soundTargets.push(heroTarget);
        heroButton.addEventListener('click', function () { toggleSound(heroTarget); });
      }
    }
    var heroSlide = heroVideo ? heroVideo.closest('[data-ms-hero-video]') : null;
    if (heroVideo && heroSlide) {
      var segStart = parseFloat(heroSlide.getAttribute('data-ms-start')) || 0;
      var segEnd = parseFloat(heroSlide.getAttribute('data-ms-end')) || 0;
      if (segEnd > 0 && segEnd <= segStart) segEnd = 0;
      if (segStart > 0 || segEnd > 0) {
        var toStart = function () {
          try { heroVideo.currentTime = segStart; } catch (e) {}
        };
        heroVideo.addEventListener('loadedmetadata', function () { if (segStart > 0) toStart(); });
        heroVideo.addEventListener('timeupdate', function () {
          var t = heroVideo.currentTime;
          if ((segEnd > 0 && t >= segEnd) || t < segStart - 0.5) toStart();
        });
        if (heroVideo.readyState >= 1 && segStart > 0) toStart();
      }
    }
    root.querySelectorAll('[data-ms-clip-btn]').forEach(function (button) {
      var clip = button.closest('.ms-clip');
      var video = clip ? clip.querySelector('video') : null;
      if (!video) return;
      var target = { video: video, button: button, label: null };
      soundTargets.push(target);
      button.addEventListener('click', function () { toggleSound(target); });
    });

    var lazyVideos = root.querySelectorAll('[data-ms-inview] video');
    if (lazyVideos.length) {
      if ('IntersectionObserver' in window) {
        var videoObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) safePlay(entry.target);
            else entry.target.pause();
          });
        }, { threshold: 0.4 });
        lazyVideos.forEach(function (video) { videoObserver.observe(video); });
      } else {
        lazyVideos.forEach(safePlay);
      }
    }

    var dotsWrap = root.querySelector('[data-ms-dots]');
    if (gallery && dotsWrap) {
      var slides = gallery.querySelectorAll('[data-ms-slide]');
      if (slides.length > 1) {
        var dots = [];
        slides.forEach(function (slide, index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ms-dot';
          dot.setAttribute('aria-label', (index + 1) + ' / ' + slides.length);
          dot.addEventListener('click', function () { gallery.scrollTo({ left: slide.offsetLeft, behavior: scrollBehavior }); });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        });
        var markDot = function () {
          var active = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
          dots.forEach(function (dot, i) { dot.setAttribute('aria-current', i === active ? 'true' : 'false'); });
        };
        gallery.addEventListener('scroll', function () { window.requestAnimationFrame(markDot); }, { passive: true });
        markDot();
        dotsWrap.hidden = false;
      }
    }

    var sticky = root.querySelector('[data-ms-sticky]');
    var mainButton = root.querySelector('[data-ms-atc]');
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(mainButton);
    }

    var delivery = root.querySelector('[data-ms-delivery]');
    if (delivery) {
      var min = parseInt(delivery.getAttribute('data-min'), 10);
      var max = parseInt(delivery.getAttribute('data-max'), 10);
      var businessOnly = delivery.getAttribute('data-business') === 'true';
      if (min > 0 && max >= min) {
        var addDays = function (count) {
          var date = new Date();
          var added = 0;
          while (added < count) {
            date.setDate(date.getDate() + 1);
            var day = date.getDay();
            if (!businessOnly || (day !== 0 && day !== 6)) added++;
          }
          return date;
        };
        var format = function (date) {
          return date.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
        };
        delivery.querySelector('[data-ms-dates]').textContent = format(addDays(min)) + ' – ' + format(addDays(max));
        delivery.hidden = false;
      }
    }

    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      addButtons.forEach(function (button) { button.removeAttribute('aria-busy'); });
      render();
    });

    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ms-root]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();